import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDriver(params) {
	return client.get("api-logistic/driver/data", {
		params: params,
	});
}

function getDetailDriver(params) {
	return client.get("api-logistic/driver/detail", {
		params: {
			driver_id : params
		},
	});
}

function addDriver(params) {
	return client.post("api-logistic/driver/add", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function updateDriver(params) {
	return client.post("api-logistic/driver/edit", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function deleteDriver(params) {
	return client.post("api-logistic/driver/delete", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function statusDriver(params) {
	return client.post("api-logistic/driver/status", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getDriver,
	getDetailDriver,
	addDriver,
	updateDriver,
	deleteDriver,
	statusDriver
};